import { render, staticRenderFns } from "./settings-company.vue?vue&type=template&id=1c95b388&"
import script from "./settings-company.vue?vue&type=script&lang=js&"
export * from "./settings-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports